import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { fetchDipStocks, selectDipStocks } from "../../dip/DipSlice";
import { selectUserWatchlist, selectIndices } from "../../watchlist/WatchlistSlice";
import styles from "./MobileDip.module.css";
import "rsuite/dist/rsuite.min.css";
import "../../../util/css/Table.css";
import Grid from "../../../components/grid/Grid";
import ScrollToTop from "../../../components/ScrollToTop/ScrollToTop";

const MobileDip = () => {

    const [dipThreshold, setDipThreshold] = useState(1);
    const [dipDuration, setDipDuration] = useState(3);
    const dispatch = useDispatch();
    const dip_stocks = useSelector(selectDipStocks);
    const watchlists = useSelector(selectUserWatchlist) || [];
    const indices = useSelector(selectIndices) || [];
    const months_array = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    const [watchlistSelected, setWatchlistSelected] = useState('');
    const [indexSelected, setIndexSelected] = useState('');

    useEffect(() => {
        //TO DO - Validate selection. Handle edge cases/ watchlist/index
        //Set a default watchlist selected
        setIndexSelected(indices[0].indexUId);
        console.log(indices[0].indexUId);
        const req = {
            months: dipDuration,
            threshold: dipThreshold,
            indexUId: indices[0].indexUId
        };
        dispatch(fetchDipStocks(req));
    }, [dispatch]);


    // const fetchCustomDipList = () => {
    //     const req = {
    //         months: parseInt(dipDuration, 10),
    //         threshold: parseInt(dipThreshold, 10),
    //     };
    //     if (watchlistSelected) req.watchlistUId = watchlistSelected;
    //     if (indexSelected) req.indexUId = indexSelected;

    //     console.log(req)
    //     dispatch(fetchDipStocks(req));
    // }

    const handleGroupSelection = (value, flag) => {
        if (flag === "W") {
            setWatchlistSelected(value);
            setIndexSelected("");
        } else {
            setWatchlistSelected("");
            setIndexSelected(value);
        }
    }

    useEffect(() => {
        const hasGroup = !!watchlistSelected || !!indexSelected;
        const hasAllFields = hasGroup && dipThreshold && dipDuration;

        if (hasAllFields) {
            const req = {
                months: parseInt(dipDuration, 10),
                threshold: parseInt(dipThreshold, 10),
            };
            if (watchlistSelected) req.watchlistUId = watchlistSelected;
            if (indexSelected) req.indexUId = indexSelected;

            dispatch(fetchDipStocks(req));
        }
    }, [watchlistSelected, indexSelected, dipThreshold, dipDuration, dispatch]);


    return (
        <div className="">
            <div className={`${styles.wrapper}`}>
                <div className={`${styles.filter_section}`}>
                    <div className={`form-row ${styles.inp_btn_wrapper}`}>
                        <div className={styles.filter_inputs_wrapper}>
                            <div className={`${styles.watchlist_dropdown_wrapper}`}>
                                {/* <label>Watchlist</label> */}
                                <div className={styles.floating_select_wrapper}>
                                    <select className={`${watchlistSelected === '' ? styles.grey_text : styles.black_text}`} value={watchlistSelected} onChange={(event) => handleGroupSelection(event.target.value, 'W')}>
                                        <option disabled value=''> Watchlist</option>
                                        {
                                            watchlists.map((item, index) => {
                                                return (
                                                    <option key={index} value={item.watchlistUId}>{item.watchlistName}</option>
                                                )
                                            })
                                        }
                                    </select>
                                    <label className={styles.floating_label}>Watchlist</label>
                                </div>
                            </div>

                            <div className={styles.watchlist_dropdown_wrapper}>
                                {/* <label>Index</label> */}
                                <div className={styles.floating_select_wrapper}>
                                    <select className={`${indexSelected === '' ? styles.grey_text : styles.black_text}`} value={indexSelected} onChange={(event) => handleGroupSelection(event.target.value, "I")}>
                                        <option disabled value=''>Index</option>
                                        {
                                            indices.map((item, index) => {
                                                return (
                                                    <option key={index} value={item.indexUId}>{item.indexName}</option>
                                                )
                                            })
                                        }
                                    </select>
                                    <label className={styles.floating_label}>Index</label>
                                </div>
                            </div>

                            <div className={`${styles.search_input_wrapper}`}>
                                {/* {dipThreshold && <label className={styles.floating_label}>Dip Percentage</label>} */}
                                <div className={styles.floating_label_1}>
                                    <input
                                        type="number"
                                        className=""
                                        placeholder=" "
                                        min={1}
                                        name="dippercent"
                                        value={dipThreshold}
                                        onChange={(event) => setDipThreshold(event.target.value)}
                                    />
                                    <label htmlFor="dippercent">Dip %</label>
                                </div>
                            </div>

                            <div className={`${styles.search_input_wrapper}`}>
                                {/* {dipDuration && <label className={styles.floating_label}>No. of Months</label>} */}
                                <div className={styles.floating_select_wrapper}>
                                    <select className={`${dipDuration === '' ? styles.grey_text : styles.black_text}`} value={dipDuration} onChange={(event) => setDipDuration(event.target.value)}>
                                        {
                                            months_array.map((month) => {
                                                return (
                                                    <option key={month} value={month}>{month}</option>
                                                )
                                            })
                                        }
                                    </select>
                                    <label className={styles.floating_label}>Months</label>

                                </div>
                            </div>

                        </div>
                        <div className={`${styles.centered_button}`}>
                            {/* <input type="button" value='SUBMIT' className={styles.filter_btn} onClick={fetchCustomDipList}></input>
                            <button className={styles.filter_clear_btn} >CLEAR</button> */}
                            {/*<button className={styles.adv_search_btn} onClick={() => toggleAdvancedSearch(showAdvancedSearch)}>Advanced Search</button>
                            <span className={styles.adv_dropdown_btn} onClick={() => toggleAdvancedSearch(showAdvancedSearch)}><IoChevronDownCircle /></span>*/}
                        </div>
                    </div>
                </div>

                <div>
                    {dip_stocks && (
                        <>
                            <Grid source={dip_stocks} />
                        </>
                    )}
                </div>
                <ScrollToTop />
            </div>
        </div>
    )
}

export default MobileDip